var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"mr-1 d-inline",attrs:{"src":_vm.src,"contain":"","max-width":"50","max-height":"20"}})}
var staticRenderFns = []

export { render, staticRenderFns }